import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["amountField"];

  toggleAmount(event) {
    const selectedState = event.target.value;
    if (selectedState === "finalize") {
      this.amountFieldTarget.style.display = "block";
    } else {
      this.amountFieldTarget.style.display = "none";
    }
  }
}
